import * as React from 'react';

const PaypalPaymentEventsContext = /*#__PURE__*/ React.createContext({
    orderType: 'regular'
});
const usePaypalPaymentEvents = ()=>React.useContext(PaypalPaymentEventsContext)
;
const PaypalPaymentEventsProvider = (props)=>{
    return /*#__PURE__*/ React.createElement(PaypalPaymentEventsContext.Provider, {
        value: props
    }, props.children);
};

export { PaypalPaymentEventsProvider, usePaypalPaymentEvents };
//# sourceMappingURL=PaypalPaymentEventsContext.js.map
